export default __webpack_public_path__ + "static/media/img2.e0ade2cd.jpg";